module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lk-93412c6fbb52d5bb809b23a3bc50271d.svg";